// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
import App from './App'
import './style/clear.css'

import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
Vue.component('ElImageViewer',ElImageViewer)
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import util from './common/util'
// import axios from 'axios'
// import Vuex from 'vuex'
import store from './store'


Vue.use(Vuex);
Vue.config.productionTip = false

Vue.prototype.$common=util;

Vue.prototype.$ajax=axios


// Vue.use(ElementUI);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js